import React, { useState, useEffect } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import Dashboard from '../../../../../layouts/Dashboard';

import CreateArea from '../../../../../components/Global/Categories/Create';

import { categoryIitQuery, Organisation } from './queries';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  organisation_id: string;
}

const CreateAreaAdmin = ({ classes, history }: Props): React.ReactElement => {
  const { organisation_id } = useParams<UrlParams>();

  const [organisation, setOrganisation] = useState<Organisation>({
    name: '',
    areas: [],
    emergencies: [],
  });

  const { data: categoryInitData } = useQuery(categoryIitQuery(organisation_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && categoryInitData) {
      setOrganisation(categoryInitData.organisations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [categoryInitData]);

  const handleFinish = (id: string) => {
    history.push(`/admin/trusts/${organisation_id}/grouping/`);
  };

  return (
    <>
      <Dashboard
        breadcrumbs={[
          { label: 'Trusts', link: '/admin/trusts' },
          { label: organisation.name, link: `/admin/trusts/${organisation_id}` },
          { label: 'Grouping', link: `/admin/trusts/${organisation_id}/grouping` },
          { label: 'Create' },
        ]}>
        <CreateArea organisation_id={organisation_id} areas={organisation.areas} emergencies={organisation.emergencies} handleFinish={handleFinish} />
      </Dashboard>
    </>
  );
};

export default withRouter(withStyles(styles)(CreateAreaAdmin));
